import { TesSalaryTableSelectionProvenance } from "../../../tesSalaryTables/tesSalaryTablesApi";
export const LOCK_ONLY_BASE_COMPONENT_CODES = true;
export const TES_TABLE_INFO_COMPONENT_CODE =
  "Palkkaryhman_mukainen_palkka_(tiedoksi)";
const NON_EDITABLE_INFO_COMPONENT_CODES = new Set([
  TES_TABLE_INFO_COMPONENT_CODE,
  "Luvanhaltijanedustajanlisa",
]);

export const isTesManagedBaseComponentCode = (code: string) => {
  if (LOCK_ONLY_BASE_COMPONENT_CODES) {
    return code === "BASE" || code.startsWith("BASE_");
  }

  return true;
};

export const isTesTableInfoComponentCode = (code: string) =>
  code === TES_TABLE_INFO_COMPONENT_CODE;

export const hasNonTableSalaryComponents = (componentCodes: string[]) =>
  componentCodes.some(
    (code) =>
      !isTesManagedBaseComponentCode(code) &&
      !NON_EDITABLE_INFO_COMPONENT_CODES.has(code),
  );

export const isTesTableLockedComponentCode = ({
  code,
  allComponentCodes = [],
  hasTesSalaryTableSelection = false,
  tesSalaryTablesAvailable = false,
}: {
  code: string;
  allComponentCodes?: string[];
  hasTesSalaryTableSelection?: boolean;
  tesSalaryTablesAvailable?: boolean;
}) => {
  if (!tesSalaryTablesAvailable) return false;

  if (isTesTableInfoComponentCode(code)) return true;

  return (
    hasTesSalaryTableSelection &&
    isTesManagedBaseComponentCode(code) &&
    hasNonTableSalaryComponents(allComponentCodes)
  );
};

export const getBaseComponentCode = (components?: Record<string, unknown>) => {
  const componentKeys = Object.keys(components || {});
  return (
    componentKeys.find((key) => isTesManagedBaseComponentCode(key)) || "BASE"
  );
};

export const applyTesSalaryTableSelectionToComponents = ({
  components,
  salaryAmount,
  baseComponentCode,
}: {
  components?: Record<string, unknown>;
  salaryAmount: string;
  baseComponentCode?: string;
}) => {
  const currentComponents = components || {};
  const resolvedBaseComponentCode =
    baseComponentCode || getBaseComponentCode(currentComponents);

  return {
    ...currentComponents,
    [resolvedBaseComponentCode]: salaryAmount,
    ...(TES_TABLE_INFO_COMPONENT_CODE in currentComponents && {
      [TES_TABLE_INFO_COMPONENT_CODE]: salaryAmount,
    }),
  };
};

export const hasManualNonBaseComponents = (
  components?: Record<string, unknown>,
) => {
  return Object.entries(components || {}).some(
    ([key, value]) =>
      !isTesManagedBaseComponentCode(key) &&
      typeof value === "string" &&
      value.trim() !== "",
  );
};

export const getAdditionalSalaryComponentsForTesTableApply = (
  components?: Record<string, unknown>,
): Record<string, string> =>
  Object.entries(components || {}).reduce<Record<string, string>>(
    (result, [key, value]) => {
      if (
        !isTesManagedBaseComponentCode(key) &&
        typeof value === "string" &&
        value.trim() !== ""
      ) {
        result[key] = value;
      }
      return result;
    },
    {},
  );

export const withFullSalaryMode = (
  selection: TesSalaryTableSelectionProvenance,
): TesSalaryTableSelectionProvenance => ({
  ...selection,
  mode: "FULL_SALARY",
});

export const withInfoOnlyMode = (
  selection: TesSalaryTableSelectionProvenance,
): TesSalaryTableSelectionProvenance => ({
  ...selection,
  mode: "INFO_ONLY",
});
